import React from "react";

const ProspectusSnapshot = ({ blueprint }) => {
  const primaryStrength = blueprint?.hiddenValueAssets?.[0]?.title || "Operational Systems Leadership";
  const bestIncomeModel = blueprint?.aiOpportunities?.[0]?.incomeModel || "Advisory + Process Optimization Consulting";
  const fastestPath = blueprint?.recommendedPath?.title || "AI-Assisted Operational Consulting";

  const rows = [
    { label: "Primary Strength Pattern", value: primaryStrength },
    { label: "Best Income Model", value: bestIncomeModel },
    { label: "Fastest Starting Path", value: fastestPath },
  ];

  return (
    <div
      className="rounded-2xl overflow-hidden"
      style={{
        border: "2px solid #d3ac35",
        boxShadow: "0 4px 24px rgba(40, 59, 163, 0.12)",
      }}
    >
      {/* Header */}
      <div
        className="px-6 py-4"
        style={{
          background: "linear-gradient(135deg, #283ba3 0%, #1e2d8a 100%)",
        }}
      >
        <h2
          className="text-lg md:text-xl font-bold text-white tracking-wide"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          Your Prospectus Snapshot
        </h2>
        <p
          className="text-sm mt-0.5"
          style={{ color: "#d3ac35", fontFamily: "var(--font-body)" }}
        >
          Key highlights from your personalized blueprint
        </p>
      </div>
      {/* Rows */}
      <div style={{ backgroundColor: "#fff8ed" }}>
        {rows?.map((row, index) => (
          <div
            key={index}
            className={`flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4 px-6 py-4 ${
              index < rows?.length - 1 ? "border-b" : ""
            }`}
            style={{ borderColor: "#e8d9b5" }}
          >
            {/* Label */}
            <div
              className="sm:w-52 flex-shrink-0 text-xs font-bold uppercase tracking-widest"
              style={{ color: "#283ba3", fontFamily: "var(--font-caption)" }}
            >
              {row?.label}
            </div>
            {/* Divider dot (desktop) */}
            <div
              className="hidden sm:block w-1.5 h-1.5 rounded-full flex-shrink-0"
              style={{ backgroundColor: "#d3ac35" }}
            />
            {/* Value */}
            <div
              className="text-sm md:text-base font-semibold flex-1"
              style={{ color: "#1a1a2e", fontFamily: "var(--font-body)" }}
            >
              {row?.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProspectusSnapshot;
